var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleeperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 10.084H4.08366V9.33398V5.41732H12.667C13.1753 5.41732 13.6628 5.61925 14.0223 5.9787L14.5526 5.44837L14.0223 5.9787C14.3817 6.33814 14.5837 6.82565 14.5837 7.33398V10.584H14.0003H2.00033H1.41699V10.084H2.00033H3.33366Z",
    fill: "#A5A5A8",
    stroke: "#A5A5A8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeperIcon);
export default __webpack_public_path__ + "static/media/sleeperIcon.701d57123fe5cfe94f37532f995896e4.svg";
export { ForwardRef as ReactComponent };